const pulse = {
  background: 'linear-gradient(90deg, #f0f0f0 25%, #e0e0e0 50%, #f0f0f0 75%)',
  backgroundSize: '200% 100%',
  animation: 'skeleton-pulse 1.5s infinite',
  borderRadius: 'var(--radius-md)',
};

export default function LoadingSkeleton({ rows = 5, card = false }) {
  return (
    <>
      <style>{`
        @keyframes skeleton-pulse {
          0% { background-position: 200% 0; }
          100% { background-position: -200% 0; }
        }
      `}</style>
      {card ? (
        <div style={{
          background: 'var(--color-bg-primary)',
          border: '0.5px solid var(--color-border-light)',
          borderRadius: 'var(--radius-lg)',
          padding: '18px 20px',
        }}>
          {Array.from({ length: rows }).map((_, i) => (
            <div key={i} style={{
              display: 'flex',
              alignItems: 'center',
              gap: 12,
              padding: '10px 0',
              borderBottom: i < rows - 1 ? '0.5px solid var(--color-border-light)' : 'none',
            }}>
              <div style={{ ...pulse, width: 32, height: 32, borderRadius: '50%', flexShrink: 0 }} />
              <div style={{ flex: 1 }}>
                <div style={{ ...pulse, height: 12, width: '60%', marginBottom: 6 }} />
                <div style={{ ...pulse, height: 10, width: '40%' }} />
              </div>
              <div style={{ ...pulse, height: 20, width: 50, borderRadius: 'var(--radius-full)' }} />
            </div>
          ))}
        </div>
      ) : (
        Array.from({ length: rows }).map((_, i) => (
          <div key={i} style={{
            display: 'flex',
            alignItems: 'center',
            gap: 12,
            padding: '12px 16px',
            borderBottom: '0.5px solid var(--color-border-light)',
          }}>
            <div style={{ ...pulse, width: 32, height: 32, borderRadius: '50%', flexShrink: 0 }} />
            <div style={{ flex: 1 }}>
              <div style={{ ...pulse, height: 12, width: '50%', marginBottom: 6 }} />
              <div style={{ ...pulse, height: 10, width: '30%' }} />
            </div>
            <div style={{ ...pulse, height: 20, width: 60, borderRadius: 'var(--radius-full)' }} />
          </div>
        ))
      )}
    </>
  );
}